module.exports = {
  translate: [ 'value', require(249) ]
};